__turbopack_context__.v({
  "option": "L1VFkq_option",
  "optionsTrayAnchor": "L1VFkq_optionsTrayAnchor",
  "optionsTrayFan": "L1VFkq_optionsTrayFan",
  "root": "L1VFkq_root",
  "trigger": "L1VFkq_trigger",
});
